import { IGameIdentityGoal } from "motw_core/Entity/IGameIdentityGoal";
import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { IGameIdentityDTO } from "../../../../../../../../motw_core/DTOs/IGameIdentityDTO";
import { StyleClass } from "../../../../Shared/Styles/CSS";
import { IdentityGoalName } from "./Name/IdentityGoalName";

export function IdentityGoalNames({
    gameIdentityGoals,
    allGoals,
    identity,
    goalNamesLoggedToday,
}: {
    gameIdentityGoals: IGameIdentityGoal[];
    allGoals: IGoal[];
    identity: IGameIdentityDTO;
    goalNamesLoggedToday: string[];
}) {
    const relevantGameIdentityGoals = gameIdentityGoals.filter(
        (gig) => gig.gameidentityid === identity.id
    );

    return (
        <div
            id={`identityGoalNames_${identity.name}`}
            className={StyleClass(`identityGoalNamesContainer`, {
                marginBottom: `10px`,
            })}
        >
            {relevantGameIdentityGoals.map((gameIdentityGoal, index) => (
                <IdentityGoalName
                    key={index}
                    identity={identity}
                    allGoals={allGoals}
                    gameIdentityGoal={gameIdentityGoal}
                    goalNamesLoggedToday={goalNamesLoggedToday}
                />
            ))}
        </div>
    );
}

export function GetGoalName(
    allGoals: IGoal[],
    gameIdentityGoal: IGameIdentityGoal
) {
    const goal = allGoals.find((g) => g.id === gameIdentityGoal.goalid);
    return goal!.name;
}

export function GetGoalIconName(
    allGoals: IGoal[],
    gameIdentityGoal: IGameIdentityGoal
) {
    const goal = allGoals.find((g) => g.id === gameIdentityGoal.goalid);
    return goal!.icon;
}
